var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoreeChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0303 11.4697C17.3232 11.7626 17.3232 12.2374 17.0303 12.5303L8.03033 21.5303C7.73744 21.8232 7.26256 21.8232 6.96967 21.5303C6.67678 21.2374 6.67678 20.7626 6.96967 20.4697L15.4393 12L6.96967 3.53033C6.67678 3.23744 6.67678 2.76256 6.96967 2.46967C7.26256 2.17678 7.73744 2.17678 8.03033 2.46967L17.0303 11.4697Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoreeChevronRight);
export default __webpack_public_path__ + "static/media/loree-chevron-right.9dbddfb133dbc6fcefa0d6d911c6485d.svg";
export { ForwardRef as ReactComponent };